import { useHistory } from "react-router-dom";
import config from "../../config";

const PrimaryLogo = (props: { className?: string }) => {
	let history = useHistory();
	return (
		<img
			className={`w-[254px] cursor-pointer ${
				props.className ? props.className : ""
			}`}
			src={config.assets.logos.localWhite}
			alt={config.assets.companyNameShort}
			onClick={() => history.push("/")}
		/>
	);
};

export default PrimaryLogo;
